import { render } from "./QuickPromptMessage.vue?vue&type=template&id=8154ce02&scoped=true"
import script from "./QuickPromptMessage.vue?vue&type=script&lang=js"
export * from "./QuickPromptMessage.vue?vue&type=script&lang=js"

import "./QuickPromptMessage.vue?vue&type=style&index=0&id=8154ce02&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8154ce02"]])

export default __exports__